import React from 'react';
import ReactDOM from 'react-dom/client';
import { defineCustomElements } from '@marcel/web-components';
import './index.css';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initUpdateService } from './services/update_service';

defineCustomElements();

// Ensure dataLayer and gtag exist early so analytics helpers can call them
;(window as any).dataLayer = (window as any).dataLayer || [];
if (typeof (window as any).gtag !== 'function') {
  // Define a lightweight gtag that pushes to dataLayer so calls are safe
  (window as any).gtag = function () {
    (window as any).dataLayer.push(arguments);
  };
}

initUpdateService();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
